module.exports = __webpack_public_path__ + "img/LinkedIn.3275a8a7.png";